// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Icon/Size.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Icon} from '@sail/ui';
import {konbini} from '@sail/icons/react/PaymentMethodIcon';

export const Size = () => (
  <>
    <Icon icon={konbini} size="xsmall" />
    <Icon icon={konbini} size="small" />
    <Icon icon={konbini} size="medium" />
    <Icon icon={konbini} size="large" />
    <Icon icon={konbini} size="xlarge" />
  </>
);
